export enum DialogResponseEnum {
  CONFIRM = 'CONFIRM', CANCEL = 'CANCEL'
}
